export const HERO_VIDEO_SRC = "/videos/fractolabs-demo.mp4";
export const HERO_VIDEO_POSTER = "/videos/fractolabs-demo-preview.png";
export const VIDEO_WATCH_MILESTONES = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
